export default __webpack_public_path__ + "static/media/arrow-back.f7de9cfc.svg";